import { render, staticRenderFns } from "./sendInvoiceWhats.vue?vue&type=template&id=4e061046"
import script from "./sendInvoiceWhats.vue?vue&type=script&lang=js"
export * from "./sendInvoiceWhats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports